<template>
  <div
    v-if="availableLocales && availableLocales.length > 1"
    class="header-language-switch"
  >
    <IconGlobe class="header-language-switch__icon" />
    <a
      v-for="locale in availableLocales"
      :key="locale.code"
      :href="`/${locale.code}`"
      class="header-language-switch__link"
      :class="{ 'header-language-switch__link-active': isCurrent(locale) }"
      data-test-id="header-language-switch-link"
      :aria-label="getAriaLabel(locale.code)"
      @click="setCode(locale.code)"
    >
      {{ getLanguageCode(locale.iso) }}
    </a>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { availableLocales, isCurrent, getLanguageCode } = useLanguageSwitch()
// SSR-safe cookie write (mirrors LanguageSwitchDialog.vue); the `$cookies`
// plugin was undefined in some SSR/hydration contexts and threw on `.set`
// (T10).
const selected_locale = useCookie('selected_locale')
const { t } = useI18n()

const setCode = (code: string) => {
  selected_locale.value = code
  return true
}

const getAriaLabel = (locale: string) => {
  return `${t('navigation.language')} ${getLanguageCode(locale)}`
}
</script>

<style lang="postcss" scoped>
.header-language-switch {
  @apply hidden
  lg:flex
  items-center;
}

.header-language-switch__icon {
  @apply mr-0.5;
}

.header-language-switch__link {
  @apply block
  p-1.5
  text-sm
  text-black-50
  uppercase
  hover:text-black
  hover:underline;
}

.header-language-switch__link-active {
  @apply pointer-events-none
  text-black;
}
</style>
